import mod from "-!./norm_page.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./norm_page.js?vue&type=script&lang=js&external"